import { useTranslate } from "@/helper/translate";

type DropdownProps<T> = {
  source: T[];
  value: string | number | undefined;
  onChange: (value: string | number) => void;
  valueMember: keyof T;
  displayMember: keyof T;
  className?: string;
  doTranslate?: boolean;
};

export function Dropdown<T>({
  source,
  value,
  onChange,
  valueMember,
  displayMember,
  className = "",
  doTranslate = false
}: DropdownProps<T>) {
  const { translate } = useTranslate();
  return (
    <select
      className={`flex h-8 px-2 w-full rounded-md border border-input dark:border-zinc-400 bg-transparent dark:bg-zinc-800 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {value === undefined && <option value="">{translate("dd.Select")}</option>}
      {source && source.map((item, index) => (
        <option key={index} value={item[valueMember] as any}>
         {doTranslate?translate("dd." + String(item[displayMember])):String(item[displayMember])}
        </option>
      ))}
    </select>
  );
}
